<template>
    <div id="demo-basic-card">
        <vx-card class="mb-base">
            <div id="allPackagesLoadingDiv" class="vs-con-loading__container" style="min-height : 300px;">
                <div class="vx-row">
                    <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base" v-if="packagesData.length" v-for="(listItem, index) in packagesData" :key="index">
                        <vx-card class="m-4">
                            <h5 class="mb-2">{{ listItem.name }}</h5>
                            <p class="text-grey">Price {{ listItem.price }} </p>
                            <p class="text-grey">{{ listItem.theory_test ? listItem.theory_test.length : 0 }} Teori Test(s)</p>
                            <p class="text-grey">{{ listItem.theory_lesson ? listItem.theory_lesson.length : 0 }} Teori Lession(s)</p>
                            <div class="flex justify-between flex-wrap">
                                <vs-button @click="editPackage(listItem)"class="mt-4 mr-2 shadow-lg" type="gradient" color="primary"  icon-pack="feather" icon="icon-edit" icon-after>Edit</vs-button>
                                <vs-button @click="deletePackage(listItem)"class="mt-4 mr-2 shadow-lg" type="gradient" color="danger"  icon-pack="feather" icon="icon-trash" icon-after>Delete</vs-button>
                            </div>
                        </vx-card>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleQuestionManagement from '@/store/question-management/moduleQuestionManagement.js'

export default{
    data() {
        return {
            packagesData: [],
            deletePackageData : null,
        }
    },
    components: {
        VuePerfectScrollbar,
    },
    methods: {
        redirectToAddPackage() {
            this.$router.push("/packages/add").catch(() => {})
        },
        deletePackage(packaged) {
            this.deletePackageData = packaged;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirm`,
                text: 'Are you sure to delete this Package data ?',
                accept: this.acceptDeletePackage
            })
        },
        acceptDeletePackage() {
            this.$vs.loading();

            this.$store.dispatch("questionManagement/deletePackage", { id : this.deletePackageData.id})
                .then(res => { 
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: "Success.",
                        text: "Package deleted successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });
                })
                .catch(err => { 
                  this.$vs.loading.close()
                })
        },
        getLessionNumber(moduleData) {
            if(moduleData.lession_number && moduleData.lession_number.length){
                return 'Lession number - '+moduleData.lession_number.join(', ');
            }
            else return ""
        },
        getAllPackages() {
            this.$vs.loading({
                container: '#allPackagesLoadingDiv',
                scale: 0.6
            })

            this.$store.dispatch("questionManagement/getAllPackages")
                .then(res => { 
                    this.packagesData = res.data
                    this.$vs.loading.close('#allPackagesLoadingDiv > .con-vs-loading')
                })
                .catch(err => { 
                    this.$vs.loading.close('#allPackagesLoadingDiv > .con-vs-loading')
                })
        },
        editPackage(packaged) {
            this.$router.push("/packages/edit/" + packaged.id).catch(() => {})
        },
    },
    mounted(){
        this.getAllPackages()
    },
    created() {
        if(!moduleQuestionManagement.isRegistered) {
            this.$store.registerModule('questionManagement', moduleQuestionManagement)
            moduleQuestionManagement.isRegistered = true
        }

        this.packagesData = this.$store.state.questionManagement.packages
    },

}
</script>

